module.exports = __webpack_public_path__ + "static/media/image3.88e10eed.JPG";